import axios from "axios";

/**
 * Ergebnis einer der Konto-Routen (backend#57, backend#66) als ein Wort fuer
 * die Oberflaeche: "OK", der Code aus der Fehlerantwort (LINK_UNGUELTIG,
 * LINK_ABGELAUFEN, CODE_UNGUELTIG, PASSWORT_ZU_KURZ), "GEBREMST" bei 429 oder
 * "FEHLER".
 */
function kontoErgebnis(anfrage) {
  return anfrage
    .then(() => "OK")
    .catch((e) => {
      const status = e && e.response && e.response.status;
      const code = e && e.response && e.response.data && e.response.data.code;
      if (status === 429) return "GEBREMST";
      return code || "FEHLER";
    });
}

/**
 * backend#150 (OD-AT-009): Registrierung bzw. "erneut senden" mit 503 und
 * diesem Code - das Konto ist angelegt, nur die Bestaetigungsmail ging nicht
 * raus. Die Oberflaeche zeigt die Meldung des Servers und "Bestätigung erneut
 * senden", keinen allgemeinen Fehler und keine zweite Registrierung.
 */
export const CODE_MAIL_NICHT_VERSENDET = "BESTAETIGUNGSMAIL_NICHT_VERSENDET";

/** Ersatz, falls der Server keine Meldung mitschickt (Wortlaut wie im Backend). */
export const MELDUNG_MAIL_NICHT_VERSENDET =
  "Dein Konto ist angelegt, aber die Bestätigungsmail konnte gerade nicht versendet werden. " +
  "Bitte fordere sie mit „Bestätigung erneut senden“ noch einmal an.";

const actions = {
  login(context, loginData) {
    context.commit("SET_LOGIN_INFO");
    return axios
      .post("login", {
        email: loginData.email.trim().toLowerCase(),
        password: loginData.password.trim(),
      })
      .then((r) => {
        /*
         * backend#9: 2FA aktiv - das Backend hat noch KEIN Sitzungstoken
         * ausgegeben, nur ein Zwischen-Token fuer den zweiten Schritt. Login.vue
         * zeigt statt des Formulars die Code-Eingabe (ZweiFaktorSchritt.vue).
         */
        if (r.data && r.data.zweiFaktor) {
          context.commit("SET_ZWEI_FAKTOR", { schritt: "code", zwischenToken: r.data.zwischenToken });
          context.commit("SET_LOGIN_INFO", null);
          return false;
        }
        if (r.data.role === "AppUser") {
          context.commit(
            "CREATE_SNACKBAR",
            "Berechtigungsfehler - Fahrer Anmeldung nur per App möglich"
          );
          context.commit("SET_LOGIN_INFO", null);
          return false;
        } else {
          localStorage.setItem("token", r.data.token);
          context.commit("SET_LOGIN_INFO", r.data);
          //backend#9: Organisation verlangt 2FA, noch nicht eingerichtet - erst
          //einrichten, dann weiter (die Sitzung oeffnet bis dahin nur /2fa)
          if (r.data.zweiFaktorEinrichten) {
            context.commit("SET_ZWEI_FAKTOR", { schritt: "einrichten" });
            return false;
          }
          return true;
        }
      })
      .catch((err) => {
        context.commit("SET_LOGIN_INFO", err);
        /*
         * backend#57 / F-10: Passwort stimmt, die Adresse ist aber noch nicht
         * bestaetigt. Kein Fehlerdialog - LoginForm zeigt den Hinweis mit
         * "Bestaetigungsmail erneut senden" (EmailUnbestaetigt.vue).
         */
        const antwort = err && err.response;
        if (antwort && antwort.status === 403 && antwort.data && antwort.data.code === "EMAIL_UNBESTAETIGT") {
          context.commit("SET_EMAIL_UNBESTAETIGT", loginData.email.trim().toLowerCase());
          return false;
        }
        context.dispatch("triggerError", err);
        return false;
      });
  },
  /** backend#57: Bestaetigungsmail erneut senden (gebremst: 3 je Stunde). */
  bestaetigungErneut(context, email) {
    return kontoErgebnis(
      axios.post("konto/emailBestaetigung/erneut", {
        email: String(email || "").trim().toLowerCase(),
      })
    );
  },
  /** backend#57: Link aus der Bestaetigungsmail einloesen. */
  emailBestaetigen(context, token) {
    return kontoErgebnis(axios.post("konto/emailBestaetigung", { token }));
  },
  /** backend#66: Gilt der Einladungslink noch? Liefert { name, email, gueltigBis } oder null. */
  einladungStatus(context, token) {
    return axios
      .post("konto/einladung/status", { token })
      .then((r) => r.data)
      .catch(() => null);
  },
  /**
   * backend#66: Passwort fuer ein Fahrerkonto selbst setzen.
   * { token, password } aus dem Link oder { email, einmalcode, password } mit dem Code.
   */
  einladungEinloesen(context, daten) {
    const body = { password: String(daten.password || "").trim() };
    if (daten.token) {
      body.token = daten.token;
    } else {
      body.email = String(daten.email || "").trim().toLowerCase();
      body.einmalcode = String(daten.einmalcode || "").replace(/[\s-]/g, "");
    }
    return kontoErgebnis(axios.post("konto/einladung", body));
  },
  register(context, registerData) {
    context.commit("SET_REGISTER_INFO");
    let val = registerData;
    //format data
    val.email ? (val.email = val.email.trim().toLowerCase()) : "";
    val.password ? (val.password = val.password.trim()) : "";
    return axios
      .post("register", val)
      .then(function (r) {
        context.commit("SET_REGISTER_INFO", r.data);
        return r.data;
      })
      .catch(function (e) {
        const antwort = e && e.response;
        //backend#150: Konto angelegt, Mail nicht versendet - kein Fehlerdialog
        if (
          antwort &&
          antwort.status === 503 &&
          antwort.data &&
          antwort.data.code === CODE_MAIL_NICHT_VERSENDET
        ) {
          context.commit("SET_REGISTER_INFO", antwort.data);
          return {
            message: "mailNichtVersendet",
            code: CODE_MAIL_NICHT_VERSENDET,
            meldung: antwort.data.message || MELDUNG_MAIL_NICHT_VERSENDET,
            emailBestaetigung: true,
          };
        }
        //ohne Antwort (Netz weg) warf e.response.status hier einen TypeError
        if (antwort && antwort.status === 400) {
          //react on email error status code
          context.commit("SET_REGISTER_INFO", e);
          context.dispatch("triggerUniversalAlert", {
            text: "Es gab ein Problem bei der Registrierung des Nutzers, bitte verwende eine andere E-Mail-Adresse.",
            heading: "Fehler - Registrierung fehlgeschlagen",
            type: "warning",
          });
        } else {
          //general error
          context.commit("SET_REGISTER_INFO", e);
          context.dispatch("triggerError", e);
        }
        return e;
      });
  },
  /**
   * Einmal-Code fuer die Weiterleitung an die Plattform (login#2) - statt das
   * Token in die Adresse zu schreiben. Liefert den Code oder null.
   */
  anmeldeCode(context) {
    const config = {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    };
    return axios
      .post("login/code", {}, config)
      .then((r) => (r && r.data && r.data.code) || null)
      .then((code) => {
        if (!code) throw new Error("kein Code");
        return code;
      })
      .catch(() => {
        context.commit(
          "CREATE_SNACKBAR",
          "Die Anmeldung konnte nicht an onDispatch übergeben werden. Bitte versuche es erneut."
        );
        return null;
      });
  },
  getUserInfo(context) {
    context.commit("SET_USER_INFO");
    const config = {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    };
    return axios
      .get("info", config)
      .then(function (r) {
        context.commit("SET_USER_INFO", r.data);
        return r.data;
      })
      .catch(function (e) {
        context.commit("SET_USER_INFO", e);
        context.dispatch("triggerError", e);
      });
  },
  resetPassword(context, postData) {
    const config = {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    };
    return axios
      .post("reset", postData, config)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  setNewPassword(context, postData) {
    const config = {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    };
    return axios
      .post("reset/" + postData.id, postData, config)
      .then(function (r) {
        //dont expect answere for sec reasons
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
